<template>
  <div
    id="app"
    class="o-typography"
  >
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    created() {
      document.body.classList.remove('loading');
      this.$deferredLoader.appReady.resolve();
    },
  };
</script>
